const searchInput = document.getElementById("searchInput");

if (searchInput) {
  console.log("hello");
}
